import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'Components';
import './MessageModal.css';

const MessageModal = (props) => (
  <Modal show={props.show}>
    <div className="message-modal">
      <div className="message-modal__container">
        <h4>{props.message}</h4>
        <div className="message-modal__buttons">
          {props.firstButtonText && (
            <Button
              onClick={props.onFirstButtonClick}
              className="button button--primary"
            >
              {props.firstButtonText}
            </Button>
          )}

          {props.secondButtonText && (
            <Button
              onClick={props.onSecondButtonClick}
              className="button button--primary"
            >
              {props.secondButtonText}
            </Button>
          )}
        </div>
      </div>
    </div>
  </Modal>
);

MessageModal.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool,
  secondButtonText: PropTypes.string,
  firstButtonText: PropTypes.string,
  onSecondButtonClick: PropTypes.func,
  onFirstButtonClick: PropTypes.func,
};

MessageModal.defaultProps = {
  show: true,
};

export default MessageModal;



// WEBPACK FOOTER //
// ./src/components/MessageModal/MessageModal.jsx